import React, { Component } from 'react';
import ExportTaskIcon from '@assets/icons/download-export-task.svg';
import ExportTask from 'FielderUtils/task/exportTask';
import { exportTaskColumns, buildTasksToExcel } from 'FielderUtils/task/exportTaskColums';
import { getExportTasksQueryParams, getExportGroupTasksQueryParams } from 'FielderUtils/task/exportTaskQueryParams';
import ReactExport from 'react-export-excel';
import { connect } from 'react-redux';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography,
  Button, Checkbox, FormControlLabel, IconButton, Avatar, TextField, Chip, Stack
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import CookieIcon from '@mui/icons-material/Cookie';
import LoadingConst from '../../Loading/LoadingConst';
import { getExportTaskCount, getExportGroupTaskCount } from 'FielderUtils/exportUtil/exportUtil';
import { getExportTaskList } from '@core/api/task/task';
import 'FielderUtils/style.css';
import 'rc-time-picker/assets/index.css';
import { loadingStart, loadingStop } from '@core/store/modules/loading/loading.slice';
import { getCookiesRequest, updateCookiesRequest } from '@core/api/cookie/cookie.service';
import { getObjectCookie } from 'FielderUtils/cookie/cookieUtil';
import CookieName from '@core/constants/cookie/cookieNameConst';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const LIMIT = 100;
const CHUNK_SIZE = 5;

class GenerateExportTask extends Component {
  constructor(props) {
    super(props);
    const excelColumns = exportTaskColumns(this.props.lan);
    this.state = {
      excelColumns: excelColumns,
      session: this.props.session,
      selectedCount: 0,
      total: excelColumns.length,
      filter: this.props.filter,
      to: this.props.to,
      from: this.props.from,
      datesFilterValues: this.props.datesFilterValues,
      advancedFilterValues: this.props.advancedFilterValues,
      data: [],
      selectedColumnValues: [ExportTask.ID_FIELDER],
      exportableData: [],
      savedColumnGroups: [],
      groupName: '',
      activeGroupIndex: null,
    };
    this.excelButtonRef = React.createRef();
  }
  componentDidMount() {
    this.loadSavedColumnGroups();
  }
  getValidColumnSet = (excelColumns) => new Set((excelColumns || []).map((column) => column.value));
  ensureBaseColumn = (values, excelColumns = this.state.excelColumns) => {
    const validSet = this.getValidColumnSet(excelColumns);
    const uniqueValues = [];
    (values || []).forEach((value) => {
      if (typeof value !== 'number' || !validSet.has(value) || uniqueValues.includes(value)) return;
      uniqueValues.push(value);
    });
    if (!uniqueValues.includes(ExportTask.ID_FIELDER) && validSet.has(ExportTask.ID_FIELDER)) {
      uniqueValues.unshift(ExportTask.ID_FIELDER);
    }
    return uniqueValues;
  };
  calculateSelectedCount = (values) => values.filter((value) => value !== ExportTask.ID_FIELDER).length;
  getValuesFromColumns = (columns) => {
    if (!Array.isArray(columns)) return [];
    return columns
      .map((column) =>
        typeof column?.number === 'number'
          ? column.number
          : typeof column?.value === 'number'
            ? column.value
            : null
      )
      .filter((value) => typeof value === 'number');
  };
  sanitizeColumns = (columns, excelColumns = this.state.excelColumns) => {
    const validSet = this.getValidColumnSet(excelColumns);
    const seen = new Set();
    const sanitized = [];
    (Array.isArray(columns) ? columns : []).forEach((column) => {
      const value =
        typeof column?.number === 'number'
          ? column.number
          : typeof column?.value === 'number'
            ? column.value
            : null;
      if (value === null || seen.has(value) || !validSet.has(value)) return;
      sanitized.push({ number: value, value });
      seen.add(value);
    });
    if (!seen.has(ExportTask.ID_FIELDER) && validSet.has(ExportTask.ID_FIELDER)) {
      sanitized.unshift({ number: ExportTask.ID_FIELDER, value: ExportTask.ID_FIELDER });
      seen.add(ExportTask.ID_FIELDER);
    }
    return sanitized;
  };
  buildGroupEntry = (name, values, excelColumns = this.state.excelColumns) => {
    const sanitizedValues = this.ensureBaseColumn(values, excelColumns);
    return {
      name,
      columns: sanitizedValues.map((value) => ({ number: value, value })),
    };
  };
  loadSavedColumnGroups = () => {
    const body = { filterCookie: { cookieName: CookieName.DOWNLOAD_EXPORT_TASK_COLUMNS } };
    const onSuccess = (resp) => {
      const cookieGroups = Array.isArray(resp?.exportTaskColumnCookie)
        ? resp.exportTaskColumnCookie
        : [];
      const savedColumnGroups = cookieGroups
        .map((group) => ({
          name: group?.name || '',
          columns: this.sanitizeColumns(group?.columns),
        }))
        .filter((group) => group.columns.length > 0);
      this.setState((prevState) => {
        const activeGroupIndex =
          typeof prevState.activeGroupIndex === 'number' && savedColumnGroups[prevState.activeGroupIndex]
            ? prevState.activeGroupIndex
            : null;
        return { savedColumnGroups, activeGroupIndex };
      });
    };
    const onError = () => {
      this.setState({ savedColumnGroups: [], activeGroupIndex: null });
    };
    getCookiesRequest(body, onSuccess, onError, null);
  };
  persistColumnGroups = (groups, options = {}) => {
    const { reload = false } = options;
    const sanitizedGroups = groups.map((group) => ({
      name: group.name,
      columns: this.sanitizeColumns(group.columns),
    }));
    const body = getObjectCookie(CookieName.DOWNLOAD_EXPORT_TASK_COLUMNS, sanitizedGroups);
    return updateCookiesRequest(body)
      .then(() => {
        if (reload) {
          this.loadSavedColumnGroups();
        }
      })
      .catch(() => {
        if (reload) {
          this.loadSavedColumnGroups();
        }
      });
  };
  handleSelectAll = () => {
    this.setState((prevState) => {
      const values = prevState.excelColumns.map((column) => column.value);
      const selectedValues = this.ensureBaseColumn(values, prevState.excelColumns);
      return {
        selectedColumnValues: selectedValues,
        selectedCount: this.calculateSelectedCount(selectedValues),
        activeGroupIndex: null,
      };
    });
  };
  /*handleSelectAll = () => {
    this.setState((prevState) => ({
      selectedColumnValues: prevState.excelColumns.map((column) => column.value),
      selectedCount: prevState.total,
    }));
  };*/
  handleUncheckSelectAll = () => {
    const baseValues = this.ensureBaseColumn([], this.state.excelColumns);
    this.setState({
      selectedColumnValues: baseValues,
      selectedCount: this.calculateSelectedCount(baseValues),
      activeGroupIndex: null,
    });
  };
  /*handleUncheckSelectAll = () => {
    this.setState({ selectedColumnValues: [ExportTask.ID_FIELDER], selectedCount: 0 });
  };*/
  generateParams = (bringTasks, offset, limit) => {
    const downloadData = this.getDownloadData();
    if (this.props.idGroup) {
      return getExportGroupTasksQueryParams(
        this.props.idGroup,
        this.props.filter,
        downloadData,
        offset,
        limit,
        bringTasks,
        this.props.filterFilterIdsTask
      );
    } else {
      return getExportTasksQueryParams(
        this.state.from.getDate(),
        this.state.from.getMonth(),
        this.state.from.getFullYear(),
        this.state.to.getDate(),
        this.state.to.getMonth(),
        this.state.to.getFullYear(),
        this.props.filter,
        this.props.tagsFilter,
        this.state.datesFilterValues,
        downloadData,
        this.state.advancedFilterValues,
        offset,
        limit,
        bringTasks
      );
    }
  };
  handleExportTasksExcel = async () => {
    this.props.dispatch(
      loadingStart({
        name: "GENERATE_EXPORT_TASK",
        config: { icon: LoadingConst.EXPORT, text: this.props.lan.exportMessage, progress: 0 },
      })
    );
    let queryExportParams = this.generateParams(false, 0, 0);
    let totalTasks = 0;
    if (this.props.idGroup) {
      totalTasks = await getExportGroupTaskCount(queryExportParams);
    } else totalTasks = await getExportTaskCount(queryExportParams);
    const totalRequests = Math.ceil(totalTasks / LIMIT);
    const requestsArray = Array.from({ length: totalRequests }, (v, k) => k);
    let data = [];
    let progress = 0;
    for (let i = 0; i < requestsArray.length; i += CHUNK_SIZE) {
      const chunk = requestsArray.slice(i, i + CHUNK_SIZE);
      await Promise.all(
        chunk.map((i) => {
          const offset = i * LIMIT;
          progress = (offset * 100) / totalTasks;
          this.props.dispatch(
            loadingStart({
              name: 'GENERATE_EXPORT_TASK',
              config: { icon: LoadingConst.EXPORT, text: this.props.lan.exportMessage, progress },
            })
          );
          const onSuccess = ({ tasks }) => data.push(...buildTasksToExcel(tasks, this.state.session, this.props.lan));
          const onError = () => this.props.dispatch(loadingStop('GENERATE_EXPORT_TASK'));
          const queryExportParams = this.generateParams(true, offset, LIMIT);
          return getExportTaskList(queryExportParams, onSuccess, onError, this.props.idGroup);
        })
      );
    }
    this.setState({ data }, () => this.downloadExcel(data));
  };
  downloadExcel = (data) => {
    data.sort((a, b) => b.idFielder - a.idFielder);
    this.props.dispatch(loadingStop('GENERATE_EXPORT_TASK'));
    if (data.length > 0) {
      this.setState({ exportableData: data }, () => {
        if (this.excelButtonRef.current) {
          this.excelButtonRef.current.click();
        }
      });
    } else {
      console.warn("Export skipped: no data.");
    }
  };
  isColumnSelected = (value) => this.state.selectedColumnValues.includes(value);
  handleToggleColumn = (event, excelColumn) => {
    const { checked } = event.target;
    this.setState((prevState) => {
      const filteredValues = prevState.selectedColumnValues.filter((value) => value !== excelColumn.value);
      const updatedValues = checked ? [...filteredValues, excelColumn.value] : filteredValues;
      const ensureBaseColumn = this.ensureBaseColumn(updatedValues, prevState.excelColumns);
      return {
        selectedColumnValues: ensureBaseColumn,
        selectedCount: this.calculateSelectedCount(ensureBaseColumn),
        activeGroupIndex: null,
      };
    });
  };
  /*handleToggleColumn = (event, excelColumn) => {
    const { checked } = event.target;
    this.setState((prevState) => {
      const filteredValues = prevState.selectedColumnValues.filter((value) => value !== excelColumn.value);
      const updatedValues = checked ? [...filteredValues, excelColumn.value] : filteredValues;
      const ensureBaseColumn = updatedValues.includes(ExportTask.ID_FIELDER)
        ? updatedValues
        : [ExportTask.ID_FIELDER, ...updatedValues];
      const nextCount = checked
        ? Math.min(prevState.total, prevState.selectedCount + 1)
        : Math.max(0, prevState.selectedCount - 1);
      return { selectedColumnValues: ensureBaseColumn, selectedCount: nextCount };
    });
  };*/
  getDownloadData = () => {
    const selectedValuesSet = new Set(this.state.selectedColumnValues);
    return this.state.excelColumns
      .filter((column) => selectedValuesSet.has(column.value))
      .map((column) => column.value);
  };
  getExcelColumns = () => {
    const selectedValuesSet = new Set(this.state.selectedColumnValues);
    return this.state.excelColumns
      .filter((column) => selectedValuesSet.has(column.value))
      .map((column) => ({
        label: column.name,
        value: column.key,
        number: column.value,
      }));
  };
  saveCookieAdvancedFilters = () => {
    const { selectedColumnValues, excelColumns, savedColumnGroups } = this.state;
    const sanitizedValues = this.ensureBaseColumn(selectedColumnValues, excelColumns);
    const selectedCount = this.calculateSelectedCount(sanitizedValues);
    if (selectedCount === 0) return;
    const trimmedName = this.state.groupName.trim();
    const name = trimmedName || `${this.props.lan.filter}${savedColumnGroups.length + 1}`;
    const newGroup = this.buildGroupEntry(name, sanitizedValues, excelColumns);
    const nextGroups = [...savedColumnGroups, newGroup];
    this.setState(
      {
        selectedColumnValues: sanitizedValues,
        selectedCount,
        savedColumnGroups: nextGroups,
        groupName: '',
        activeGroupIndex: nextGroups.length - 1,
      },
      () => this.persistColumnGroups(this.state.savedColumnGroups, { reload: true })
    );
  };
  handleApplySavedGroup = (index) => {
    this.setState((prevState) => {
      const group = prevState.savedColumnGroups[index];
      if (!group) return {};
      const columnValues = this.ensureBaseColumn(this.getValuesFromColumns(group.columns), prevState.excelColumns);
      return {
        selectedColumnValues: columnValues,
        selectedCount: this.calculateSelectedCount(columnValues),
        activeGroupIndex: index,
      };
    });
  };
  handleDeleteSavedGroup = (index) => {
    this.setState((prevState) => {
      const nextGroups = prevState.savedColumnGroups.filter((_, idx) => idx !== index);
      const activeRemoved = prevState.activeGroupIndex === index;
      const adjustedActiveIndex =
        prevState.activeGroupIndex != null && prevState.activeGroupIndex > index
          ? prevState.activeGroupIndex - 1
          : activeRemoved
            ? null
            : prevState.activeGroupIndex;
      if (activeRemoved) {
        const baseValues = this.ensureBaseColumn([], prevState.excelColumns);
        return {
          savedColumnGroups: nextGroups,
          activeGroupIndex: adjustedActiveIndex,
          selectedColumnValues: baseValues,
          selectedCount: this.calculateSelectedCount(baseValues),
        };
      }
      return { savedColumnGroups: nextGroups, activeGroupIndex: adjustedActiveIndex };
    }, () => this.persistColumnGroups(this.state.savedColumnGroups, { reload: true }));
  };
  render() {
    return (
      <React.Fragment>
        <Dialog
          open onClose={this.props.onClose}
          fullWidth
          maxWidth="lg"
          slotProps={{
            paper: {
              sx: {
                position: 'relative', overflow: 'visible', borderRadius: 2, width: 'auto'
              },
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar src={ExportTaskIcon} alt='' sx={{ width: 32, height: 32 }} />
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                {this.props.lan.exportTask}
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                {this.state.selectedCount} {this.props.lan.selectedElements} / {this.state.total}
              </Typography>
            </Box>
            <IconButton
              onClick={this.props.onClose}
              size="medium"
              sx={{
                position: 'absolute', top: -8, right: -8, width: 24, height: 24, bgcolor: '#fff',
                border: '0px solid #dc5c87', zIndex: 10, boxShadow: 2, p: 0,
                '&:hover': { bgcolor: '#dc5c87' },
              }}
            >
              <CloseIcon
                fontSize="medium"
                sx={{ color: '#dc5c87', '&:hover': { color: '#fff' } }}
              />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3 }}>
            <ExcelFile
              filename={this.props.lan.downloadTaskFileName}
              element={<Button ref={this.excelButtonRef} sx={{ display: 'none' }}>{this.props.lan.download}</Button>}
            >
              <ExcelSheet data={this.state.exportableData} name={this.props.lan.tasks}>
                {this.getExcelColumns().map((col) => (
                  <ExcelColumn key={col.number} label={col.label} value={col.value} />
                ))}
              </ExcelSheet>
            </ExcelFile>
            {this.state.savedColumnGroups.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  {this.state.savedColumnGroups.map((group, index) => {
                    const isActive = this.state.activeGroupIndex === index;
                    const label = group.name?.trim() ? group.name : `${this.props.lan.filter} ${index + 1}`;
                    return (
                      <Chip
                        key={`export-column-group-${index}`}
                        label={label}
                        size="small"
                        variant={isActive ? 'filled' : 'outlined'}
                        icon={<CookieIcon fontSize="small" />}
                        onClick={() => this.handleApplySavedGroup(index)}
                        onDelete={() => this.handleDeleteSavedGroup(index)}
                        deleteIcon={<ClearIcon fontSize="small" />}
                        sx={{
                          bgcolor: isActive ? '#dc5c87' : 'transparent',
                          borderColor: '#dc5c87',
                          color: isActive ? '#fff' : '#dc5c87',
                          '& .MuiChip-label': { color: 'inherit' },
                          '& .MuiChip-deleteIcon': {
                            color: isActive ? 'rgba(255,255,255,0.9)' : '#dc5c87',
                          },
                          '& .MuiChip-icon': { color: 'inherit' },
                          '&:hover': {
                            bgcolor: isActive ? '#c64c75' : 'rgba(220,92,135,0.08)',
                          },
                        }}
                      />
                    );
                  })}
                </Stack>
              </Box>
            )}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              {this.props.lan.selectOptions}
            </Typography>
            <Box sx={{ maxHeight: 350, overflow: 'auto' }}>
              <Grid container spacing={0}>
                {this.state.excelColumns.map((excelColumn) => (
                  <Grid size={{ xs: 12, sm:6, md: 4, lg:4 }} key={excelColumn.value}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.isColumnSelected(excelColumn.value)}
                          onChange={(event) => this.handleToggleColumn(event, excelColumn)}
                          disabled={excelColumn.value === ExportTask.ID_FIELDER}
                        />
                      }
                      label={<Typography variant="body2">{excelColumn.name}</Typography>}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button variant="outlined" color="primary" onClick={this.handleSelectAll}>
              {this.props.lan.selectAll}
            </Button>
            <Button variant="outlined" color="primary" onClick={this.handleUncheckSelectAll}>
              {this.props.lan.uncheckEverything}
            </Button>
            <TextField
              size="small"
              placeholder={this.props.lan.filterName}
              value={this.state.groupName}
              onChange={(e) => this.setState({ groupName: e.target.value })}
            />
            <Button
              size="small"
              onClick={this.saveCookieAdvancedFilters}
              sx={{ color: '#dc5c87', border: '1px solid #dc5c87' }}
            >
              {this.props.lan.saveFilter}
            </Button>
            <Box sx={{ flexGrow: 1 }} />
            <Button variant="contained" color="primary" onClick={this.handleExportTasksExcel}>
              {this.props.lan.download}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({ session: state.utils.session });
export default connect(mapStateToProps)(GenerateExportTask);
/*import React, { Component } from 'react';
import ExportTaskIcon from '@assets/icons/download-export-task.svg';
import ExportTask from 'FielderUtils/task/exportTask';
import { exportTaskColumns, buildTasksToExcel } from 'FielderUtils/task/exportTaskColums';
import { getExportTasksQueryParams, getExportGroupTasksQueryParams } from 'FielderUtils/task/exportTaskQueryParams';
import ReactExport from 'react-export-excel';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';
import LoadingConst from '../../Loading/LoadingConst';
import { getExportTaskCount , getExportGroupTaskCount } from 'FielderUtils/exportUtil/exportUtil';
import { getExportTaskList } from '@core/api/task/task';
import '../MyOperation.css';
import { loadingStart, loadingStop } from '@core/store/modules/loading/loading.slice';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var downloadData = [ExportTask.ID_FIELDER];
var columnsExcel = [];
var LIMIT = 100;
var CHUNK_SIZE = 5;

class GenerateExportTask extends Component {
	constructor(props) {
		super(props);
		const excelColumns = exportTaskColumns(this.props.lan);
		this.state = {
			excelColumns: excelColumns,
			session: this.props.session,
			selectedCount: 0,
			total: excelColumns.length,
			filter: this.props.filter,
			to: this.props.to,
			from: this.props.from,
			datesFilterValues: this.props.datesFilterValues,
			advancedFilterValues: this.props.advancedFilterValues,
			data: [],
		};
	}
	componentDidMount = () => {
		columnsExcel = [{ label: this.props.lan.idFielder, value: 'idFielder', number: ExportTask.ID_FIELDER }];
	};
	addDataToDownload(value, columData) {
		downloadData.push(value);
		var selectedCount = this.state.selectedCount + 1;
		this.setState({ selectedCount: selectedCount });
		columnsExcel.push(columData);
	}
	deleteDataToDownload(value, columData) {
		for (let i = 0; i < downloadData.length; i++) {
			if (downloadData[i] === value) downloadData.splice(i, 1);
		}
		for (let i = 0; i < columnsExcel.length; i++) {
			if (columnsExcel[i].number === columData.number) columnsExcel.splice(i, 1);
		}
		var selectedCount = this.state.selectedCount - 1;
		this.setState({ selectedCount: selectedCount });
	}
	handleSelectAll = () => {
		downloadData = [0];
		columnsExcel = [
			{
				label: this.props.lan.idFielder,
				value: 'idFielder',
				number: ExportTask.ID_FIELDER,
			},
		];
		var excelValue = this.state.excelColumns;
		for (let i = 0; i < excelValue.length; i++) {
			document.getElementById('checkboxTask' + i).checked = true;
			if (excelValue[i].value !== 0) {
				downloadData.push(excelValue[i].value);
				columnsExcel.push({
					label: excelValue[i].name,
					value: excelValue[i].key,
					number: excelValue[i].value,
				});
			}
		}
		this.setState({ selectedCount: this.state.total });
	};
	handleUncheckSelectAll = () => {
		downloadData = [0];
		columnsExcel = [{ label: this.props.lan.idFielder, value: 'idFielder', number: ExportTask.ID_FIELDER }];
		var excelValue = this.state.excelColumns;
		for (let i = 0; i < excelValue.length; i++) {
			if (excelValue[i] !== 0) document.getElementById('checkboxTask' + i).checked = false;
		}
		this.setState({ selectedCount: 0 });
	};
	generateParams = (bringTasks, offset, limit) => {
		if (this.props.idGroup) {
			return getExportGroupTasksQueryParams(
				this.props.idGroup,
				this.props.filter,
				downloadData,
				offset,
				limit,
				bringTasks,
				this.props.filterFilterIdsTask
			);
		} else {
			return getExportTasksQueryParams(
				this.state.from.getDate(),
				this.state.from.getMonth(),
				this.state.from.getFullYear(),
				this.state.to.getDate(),
				this.state.to.getMonth(),
				this.state.to.getFullYear(),
				this.props.filter,
				this.props.tagsFilter,
				this.state.datesFilterValues,
				downloadData,
				this.state.advancedFilterValues,
				offset,
				limit,
				bringTasks
			);
		}
	};
	handleExportTasksExcel = async () => {
		this.props.dispatch(
			loadingStart({
				name: "GENERATE_EXPORT_TASK",
				config: { icon: LoadingConst.EXPORT, text: this.props.lan.exportMessage, progress: 0 },
			})
		);
		this.setState({ downloadData: downloadData });
		let queryExportParams = this.generateParams(false, 0, 0);
		let totalTasks = 0;
		if (this.props.idGroup) {
			totalTasks = await getExportGroupTaskCount(queryExportParams);
		} else totalTasks = await getExportTaskCount(queryExportParams);
		const totalRequests = Math.ceil(totalTasks / LIMIT);
		const requestsArray = Array.from({ length: totalRequests }, (v, k) => k);
		let data = [];
		let progress = 0;
		for (let i = 0; i < requestsArray.length; i += CHUNK_SIZE) {
			const chunk = requestsArray.slice(i, i + CHUNK_SIZE);
			await Promise.all(
				chunk.map((i) => {
					const offset = i * LIMIT;
					progress = (offset * 100) / totalTasks;
					this.props.dispatch(
						loadingStart({
							name: 'GENERATE_EXPORT_TASK',
							config: { icon: LoadingConst.EXPORT, text: this.props.lan.exportMessage, progress },
						})
					);
					const onSuccess = ({ tasks }) => data.push(...buildTasksToExcel(tasks, this.state.session, this.props.lan));
					const onError = () => this.props.dispatch(loadingStop('GENERATE_EXPORT_TASK'));
					const queryExportParams = this.generateParams(true, offset, LIMIT);
					return getExportTaskList(queryExportParams, onSuccess, onError, this.props.idGroup);
				})
			);//.then(() => this.setState({ data: data }));
		}
    this.setState({ data }, () => this.downloadExcel(data));
		//this.downloadExcel(this.state.data);
	};
	downloadExcel = (data) => {
		data.sort((a, b) => b.idFielder - a.idFielder);
		this.props.dispatch(loadingStop('GENERATE_EXPORT_TASK'));
    if (data.length > 0) {
      this.setState({ exportableData: data }, () => {
        document.getElementById('myExcellModal').click();
      });
    } else {
      console.warn("Export skipped: no data.");
    }
	};
	render() {
		return (
			<React.Fragment>
				<Modal
					show={true}
					size='xl'
					className='Fielder-modals-header-border Fielder-modals-content-border'
					onHide={this.props.onClose}
				>
					<Modal.Header
						className='Fielder-modals-header-border no-padding-bottom Fielder-modals-content-border'
						closeButton
					>
						<Modal.Title className='full-width'>
							<Row className='full-width ml-2 '>
								<div className='col-auto padding-right'>
									<Image src={ExportTaskIcon} style={{ width: '20px' }} alt='' />
								</div>
								<div className='col-auto padding-lef ml-2 mt-2'>
									<p className='Fielder-modal-popUp-title padding-lef-title '> {this.props.lan.exportTask} </p>
								</div>
								<div className='col d-flex justify-content-end mt-2'>
									<span style={{ fontSize: '16px' }}>
										{this.state.selectedCount} {this.props.lan.selectedElements} / {this.state.total}
									</span>
								</div>
							</Row>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<ExcelFile
							filename={this.props.lan.downloadTaskFileName}
							element={<button id='myExcellModal' hidden></button>}
						>
							<ExcelSheet data={this.state.exportableData} name={this.props.lan.tasks}>
								{columnsExcel.map((col) => {
									return <ExcelColumn label={col.label} value={col.value} />;
								})}
							</ExcelSheet>
						</ExcelFile>
						<div className='row'>
							<div className='col mt-3 mx-4 mb-3'>{this.props.lan.selectOptions}</div>
						</div>
						<Scrollbars style={{ height: '350px', width: '100%' }}>
							<div className='row mx-2'>
								{this.state.excelColumns.map((excelColumn, index) => {
									return (
										<React.Fragment>
											<div className='col-4' key={index}>
												<div className='row'>
													<div className='col-auto'>
														<input
															className='form-check-input labelCheckbox d-none'
															type='checkbox'
															value={excelColumn.value}
															checked={excelColumn.value === 0 ? true : null}
															disabled={excelColumn.value === 0 ? true : null}
															id={'checkboxTask' + index}
															onClick={() => {
																var validateChecked = document.getElementById('checkboxTask' + index).checked;
																if (validateChecked === true) {
																	this.addDataToDownload(excelColumn.value, {
																		label: excelColumn.name, value: excelColumn.key, number: excelColumn.value
																	});
																} else {
																	this.deleteDataToDownload(excelColumn.value, {
																		label: excelColumn.name, value: excelColumn.key, number: excelColumn.value
																	});
																}
															}}
														/>
														<label key={excelColumn.key} htmlFor={'checkboxTask' + index} className='round-checkbox'></label>
													</div>
													<div className='col-auto no-padding'>
														<span className='textFormat-taskGroupDetail-task'>{excelColumn.name}</span>
													</div>
												</div>
											</div>
										</React.Fragment>
									);
								})}
							</div>
						</Scrollbars>
						<div className='row mb-3 mx-2'>
							<div className='col-auto d-flex justify-content-start mt-2'>
								<button
									type='submit'
									className='btn btn-outline-primary btn-success create-edit-modal-btnsave-size font-size-taskgroup'
									onClick={this.handleSelectAll}
								>{this.props.lan.selectAll}</button>
							</div>
							<div className='col-auto d-flex justify-content-start mt-2'>
								<button
									type='submit'
									className='btn btn-outline-primary btn-success create-edit-modal-btnsave-size font-size-taskgroup'
									onClick={this.handleUncheckSelectAll}
								>{this.props.lan.uncheckEverything}</button>
							</div>
							<div className='col d-flex justify-content-end mt-2'>
								<button
									type='submit'
									className='btn btn-outline-primary btn-success create-edit-modal-btnsave-size font-size-taskgroup'
									onClick={this.handleExportTasksExcel}
								>{this.props.lan.download}</button>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</React.Fragment>
		);
	}
}
const mapStateToProps = (state) => ({ session: state.utils.session });
export default connect(mapStateToProps)(GenerateExportTask);*/
